export const APPINSIGHTS_STRINGS = {
  addWidget: "Dashboard : Add Widget",
  updateWidget: "Dashboard : Widget Updated",
  sortWidget: "Dashboard : Sort widgets",
  deleteWidget: "Dashboard : Delete Widget",
  editWidgetClick: "Dashboard : Edit Widget Clicked",
  dateChange: "Reports : Date Changed",
  generateReport: "Reports : Generate Report",
  dateRangeChange: "Reports : Date Range Changed",
  sortWidgetsInReports: "Reports : Sort widgets",
  deleteWidgetInReports: "Reports : Delete Widget",
  updateWidgetInReports: "Reports : Update Widget",
  addWidgetInReports: "Reports : Add Widget",
  mobileNumberChange: "Account Settings : Mobile Number Changed",
  accountSettingsSubmit: "Account Settings : Submit",
  alarmHistoryRowClick: "Alarm History : Row Item Clicked",
  alarmListRowClick: "Alarm List : Row Item Clicked",
  alarmListFilterChange: "Alarm List : Filter Changed",
  alarmListRowEdit: "Alarm List : Row Item Edited",
  baselineRowClick: "Baseline : Row Item Clicked",
  baselineDeleteClick: "Baseline : Delete Button Clicked",
  baselineCreateInCharts: "Charts : Create Baseline Clicked",
  plotZoom: "Charts : Plot Zoomed",
  plotRefresh: "Charts : Plot Refreshed",
  plotDownload: "Charts : Plot Downloaded",
  downloadDocument: "Document download",
  deleteDocument: "Document delete",
  uploadDocument: "Document upload",
  notificationsAddReceiverClick: "Notifications : Add Receiver Clicked",
  notificationsDeleteRowClick: "Notifications : Delete Row Item Clicked",
  notificationsRowClick: "Notifications : Row Item Clicked",
  systemEditClick: "Systems : Edit clicked",
  systemDeleteClick: "Systems : Delete clicked",
  systemDownloadClick: "Systems : Download clicked",
  systemDeleted: "Systems : Deleted a system",
  systemRowClick: "Systems : Row Item Clicked",
  addNewSystem: "Systems : Add New System",
  editSystem: "Systems : Edit System",
  insightsHistoryRowClick: "Smart Insights History : Row Item Clicked",
  insightsListRowClick: "Smart Insights List : Row Item Clicked",
  insightsListFilterChange: "Smart Insights List : Filter Changed",
  insightsListRowEdit: "Smart Insights List : Row Item Edited",
  editTag: "Tags : Edit Clicked",
  tagsRowClick: "Tags : Row Item Clicked",
  addUserClick: "Users : Add user clicked",
  editUserClick: "Users : Edit user clicked",
  deleteUserClick: "Users : Delete user clicked",
  userDeleted: "Users : User deleted",
  usersRowClick: "Users : Row Item clicked",
  smartInsightsRowClick: "Smart Insights row item clicked",
  alarmRowClick: "Alarm Row Item Clicked",
  alarmReadToggle: "Alarm Read state toggled",
  insightsDropDownOpen: "Header : Smart Insights drop down opened",
  insightsToggleSorting: "Smart Insights : Sort toggled",
  alarmsDropDownOpen: "Header : Alarms drop down opened",
  alarmsToggleSorting: "Alarms : Sort toggled",
  markAllAlarmsReadClicked: "Alarms : Mark All Read clicked",
  markAllAlarmsReadToggled: "Alarms : Mark All Read toggled",
  headerUserMenuOpen: "Header : User Menu opened",
  userMenuOptionClicked: "User Menu : Option clicked",
  addLayoutFormSubmitted: "Add Layout Form Submitted",
  editLayoutFormSubmitted: "Edit Layout Form Submitted"
};
